import { Box } from "@mui/material"
import { CategoryModal } from "./CategoryModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { CategoryData } from "../../types";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";

interface EditCategoryProps {
  refetchCategories: () => void;
  categories: CategoryData[];
}

export const EditCategory = ({ categories, refetchCategories }: EditCategoryProps) => {
  const { category_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [category, setCategory] = useState<CategoryData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/categories');
  }
  
  const handleSave = () => {
    navigate('/categories');
    refetchCategories();
  }
  
  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/categories/${category_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setCategory(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, category_id]);

  return (
    <Box className="edit-category">
      <CategoryModal open={open} handleClose={handleClose} handleSave={handleSave} category={category} categories={categories} />
    </Box>
  )
}